import gql from "graphql-tag";

export const MY_CAFETERIA_GET_ARCHIVED_STATEMENT_ITEMS = gql`
  query getArchivedCafeteriaItems($contractCode: String!) {
    getArchivedCafeteriaItems(contractCode: $contractCode) {
      origin
      contractCode
      menuItem {
        code
        name
        isReusable
      }
      startDate
      endDate
      itemSerial
      type
      amount
      cost
      plan
      periodStartDate
      _id
    }
  }
`;
